import React, { useState } from "react"
import { graphql } from "gatsby"
import { BlocksRenderer } from "@strapi/blocks-react-renderer"
import { HtmlTag } from "../libs/helpers"

import * as styles from "./videocarousel.module.scss"
import YouTube from "react-youtube"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const VideoCarousel = ({ title, videos }) => {
  const imgs = videos.map(video => video.thumbnail ? getImage(video.thumbnail.localFile) : undefined)
  const [activeSlide, setActiveSlide] = useState(0)
  const [nextSlide, setNextSlide] = useState(1)

  const next = () => {
    setActiveSlide((activeSlide + 1) % 3)
    setNextSlide((nextSlide + 1) % 3)
  }
  const previous = () => {
    let dActive = activeSlide - 1
    let dNext = nextSlide - 1
    if (dActive < 0) {
      dActive = videos.length - 1
    }
    if (dNext < 0) {
      dNext = videos.length - 1
    }
    setActiveSlide(dActive % 3)
    setNextSlide(dNext % 3)
  }

  return (
    <section>
      <div className={styles['wrap']}>
        <div className={styles['inner']}>
          <div className={styles['content']}>
            { title &&
              <HtmlTag tagName={title.header} className={styles['title']}>
                {title.copy}
              </HtmlTag>
            }
            <HtmlTag tagName='h3' className={styles['titleVideo']}>
              { videos[activeSlide].title }
            </HtmlTag>
            { videos[activeSlide].description &&
            <div>
              <BlocksRenderer content={videos[activeSlide].description} />
            </div>
            }
            <div className={styles['nextUp']}>
              <strong>Next up:</strong>
              <button className={styles['thumbnail']} onClick={next}>
                { imgs[nextSlide] &&
                <GatsbyImage image={imgs[nextSlide]} alt={imgs[nextSlide].alternativeText || 'alt'} />
                }
              </button>
              <div>{videos[nextSlide].title}</div>
            </div>
          </div>

          <div className={styles['youtube']}>
            <YouTube videoId={videos[activeSlide].youtube} />
          </div>

          <div className={styles['carouselNav']}>
            <button className="button" onClick={previous}>
              &lsaquo;
            </button>
            <span>
              {activeSlide+1}/{videos.length}
            </span>
            <button className="button" onClick={next}>
              &rsaquo;
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default VideoCarousel

export const query = graphql`
  fragment VidCarouselData on STRAPI__COMPONENT_SUPERCUSTOM_VIDEO_CAROUSEL {
    title {
      copy
      header
    }
    videos {
      description {
        children {
          text
          type
        }
        type
      }
      title
      thumbnail {
        alternativeText
        localFile {
          childImageSharp {
            gatsbyImageData
          }
        }  
      }
      youtube
    }
  }
`